// ------------------------------------------
// お客様の声のモーダル
// ------------------------------------------
class VoiceModal {
  constructor(el, opt) {
    this.modal = document.querySelector('.' + el);
    if (this.modal) {
      this.slides = this.modal.querySelectorAll('.js-voice-slide');
      this.current = this.modal.querySelector('.js-voice-current');
      this.box = this.modal.querySelector('.js-voice-box');
      this.scrollbar = this.modal.querySelector('.js-voice-scrollbar');
      this.thumb = this.modal.querySelector('.js-voice-thumb');
      this.index = 0;
      this.drag = null;
      this.trap = new FocusTrap(this.modal.querySelector('[role="dialog"]') || this.modal);
      this.event();
    }
  }

  event() {
    document.querySelectorAll('.js-voice-open').forEach((btn, i) => {
      btn.addEventListener('click', () => this.open(i));
    });

    this.modal.querySelectorAll('.js-voice-close').forEach((btn) => {
      btn.addEventListener('click', () => this.close());
    });

    const prev = this.modal.querySelector('.js-voice-prev');
    const next = this.modal.querySelector('.js-voice-next');
    if (prev) prev.addEventListener('click', () => this.goTo(this.index - 1, -1));
    if (next) next.addEventListener('click', () => this.goTo(this.index + 1, 1));

    document.addEventListener('keydown', (e) => {
      if (!this.modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') this.close();
      if (e.key === 'ArrowLeft') this.goTo(this.index - 1, -1);
      if (e.key === 'ArrowRight') this.goTo(this.index + 1, 1);
    });

    let startX = null;
    this.box.addEventListener('touchstart', (e) => {
      startX = e.changedTouches[0].clientX;
    }, { passive: true });
    this.box.addEventListener('touchend', (e) => {
      if (startX === null) return;
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) this.goTo(this.index + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
      startX = null;
    });

    this.bindScrollbar();
  }

  bindScrollbar() {
    if (!this.scrollbar || !this.thumb) return;

    const update = () => this.updateScrollbar();
    this.box.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    this.box.querySelectorAll('img').forEach((img) => {
      img.addEventListener('load', update);
    });
    if (window.ResizeObserver) {
      const observer = new ResizeObserver(update);
      observer.observe(this.box);
    }

    this.thumb.addEventListener('pointerdown', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.drag = { y: e.clientY, scroll: this.box.scrollTop };
      this.thumb.setPointerCapture(e.pointerId);
    });
    this.thumb.addEventListener('pointermove', (e) => {
      if (!this.drag) return;
      const travel = this.scrollbar.clientHeight - this.thumb.offsetHeight;
      const max = this.box.scrollHeight - this.box.clientHeight;
      if (travel <= 0 || max <= 0) return;
      this.box.scrollTop = this.drag.scroll + (e.clientY - this.drag.y) * (max / travel);
    });
    const endDrag = () => {
      this.drag = null;
    };
    this.thumb.addEventListener('pointerup', endDrag);
    this.thumb.addEventListener('pointercancel', endDrag);

    this.scrollbar.addEventListener('pointerdown', (e) => {
      if (e.target === this.thumb) return;
      const rect = this.scrollbar.getBoundingClientRect();
      const travel = rect.height - this.thumb.offsetHeight;
      const max = this.box.scrollHeight - this.box.clientHeight;
      if (travel <= 0 || max <= 0) return;
      const ratio = (e.clientY - rect.top - this.thumb.offsetHeight / 2) / travel;
      this.box.scrollTop = Math.min(Math.max(ratio, 0), 1) * max;
    });
  }

  updateScrollbar() {
    if (!this.scrollbar || !this.thumb) return;
    const max = this.box.scrollHeight - this.box.clientHeight;
    const show = max > 1;
    this.scrollbar.classList.toggle('is-hidden', !show);
    if (!show) return;

    const track = this.scrollbar.clientHeight;
    const thumbH = Math.max(track * (this.box.clientHeight / this.box.scrollHeight), Math.min(track * 0.12, track));
    const y = (track - thumbH) * (this.box.scrollTop / max);
    this.thumb.style.height = `${thumbH}px`;
    this.thumb.style.transform = `translateY(${y}px)`;
  }

  open(index) {
    this.modal.classList.add('is-instant');
    this.goTo(index, 1);
    this.modal.offsetHeight;
    this.modal.classList.remove('is-instant');
    this.modal.classList.add('is-open');
    this.modal.setAttribute('aria-hidden', 'false');
    lockBodyScroll();
    this.trap.activate(this.modal.querySelector('.p-top__voice-modal-close'));
    this.updateScrollbar();
  }

  close() {
    if (!this.modal.classList.contains('is-open')) return;
    this.modal.classList.remove('is-open');
    this.modal.setAttribute('aria-hidden', 'true');
    unlockBodyScroll();
    this.trap.deactivate();
  }

  goTo(index, dir = 1) {
    const total = this.slides.length;
    const prev = this.index;
    this.index = (index + total) % total;
    this.slides.forEach((slide, i) => {
      slide.style.setProperty('--dir', dir);
      slide.classList.toggle('is-leave', i === prev && i !== this.index);
      slide.classList.toggle('is-active', i === this.index);
    });
    if (this.current) this.current.textContent = this.index + 1;
    this.box.scrollTop = 0;
    this.updateScrollbar();
  }
}
